<template>
  <h2>Danh sách Phòng ban</h2>
  <el-button type="success" @click="dialogDepartment = true">Thêm mới</el-button>
  <el-table :data="tableData" style="width: 100%">
    <el-table-column fixed prop="no" label="STT" width="100" />
    <el-table-column prop="code" label="Mã phòng ban" width="150" />
    <el-table-column prop="name" label="Tên phòng ban" width="200" />
    <el-table-column align="right" width="300">
      <template #header>
        <el-input v-model="query.keySearch" size="default" placeholder="Tìm kiếm...." @change="getList()" />
      </template>
      <template #default="scope">
        <el-button size="small" @click="handleEdit(scope.row)">
          Edit
        </el-button>
        <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.row)"
        >
          Delete
        </el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      size="small"
      background
      layout="prev, pager, next"
      :page-size="query.size"
      :total="query.total"
      class="mt-4"
      @current-change="handleCurrentChange"
  />
  <el-dialog v-model="dialogDepartment" title="Thông tin phòng ban" width="800">
    <el-form :model="form" label-width="auto">
      <el-form-item label="Mã phòng ban">
        <el-input v-model="form.code" autocomplete="off" />
      </el-form-item>
      <el-form-item label="Tên phòng ban">
        <el-input v-model="form.name" autocomplete="off" />
      </el-form-item>
      <el-form-item label="Nhân viên">
        <el-transfer
            style="--el-transfer-panel-width: 250px;"
            v-model="form.staffs"
            filterable
            :filter-method="filterMethod"
            filter-placeholder="Tìm kiếm"
            :titles="['Nhân viên chưa gán', 'Nhân viên đã gán']"
            :data="staffs"
        />
      </el-form-item>
      <el-form-item label="Phân quyền">
        <el-checkbox-group v-model="form.permissions">
          <el-checkbox label="/admin/dashboard">Trang chủ</el-checkbox>
          <el-checkbox label="/admin/department">Phòng ban</el-checkbox>
          <el-checkbox label="/admin/staff">Nhân viên</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <p>
        <el-text class="mx-1" type="danger" style="font-style: italic">{{msgErr}}</el-text>
      </p>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogDepartment = false">Hủy</el-button>
        <el-button type="primary" @click="saveDepartment()">
          Lưu
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import {ElTable, ElTableColumn} from "element-plus";
import {onMounted, reactive, ref} from 'vue'
import {list, create, deleteDepartment, update} from '@/api/department'
import {listNotPaging} from '@/api/staff'
import { ElNotification } from 'element-plus'

let tableData = ref([])
let staffs = ref([])
const dialogDepartment = ref(false)
const query = reactive({
  page: 1,
  size: 20,
  total: 0,
  keySearch: ''
})
const form = reactive({
  id: '',
  code: '',
  name: '',
  staffs: [],
  permissions: []
})
let msgErr = ref('')

const handleEdit = (item) => {
  Object.assign(form, {
    id: item._id,
    code: item.code,
    name: item.name,
    permissions: item.permissions,
    staffs: item.staffs,
  })
  dialogDepartment.value = true
}

const handleDelete = async (item) => {
  if(item.staffs?.length) {
    ElNotification({
      title: 'Error',
      message: 'Phòng ban này đang gán nhân viên, không thể xoá!!!',
      type: 'error',
    })
    return
  }
  return deleteDepartment(item._id).then(() => {
      getList()
  }).catch(e => {
    ElNotification({
      title: 'Error',
      message: e,
      type: 'error',
    })
  })
}

const saveDepartment = async () => {
  try {
    if(!form.id) {
      await create(form)
    } else {
      await update(form.id, form)
    }
    await getList()
    resetData()
    dialogDepartment.value = false
  } catch (e) {
    msgErr = e
  }
}

const handleCurrentChange = (val) => {
  query.page = val
  getList()
}

const resetData = () => {
  Object.assign(form, {
    id: '',
    code: '',
    name: '',
    permissions: [],
    staffs: []
  })
}

const getList = () => {
  return list(query.page, query.size, query.keySearch)
      .then(res => {
        tableData.value = res.list.map((item, idx) => {
          return {
            no: idx + 1,
            ...item,
          }
        })
        query.total = res.total
      })
}

const filterMethod = (query, item) => {
  return item.label.toLowerCase().includes(query.toLowerCase())
}

const getStaffs = async () => {
  staffs = []
  return listNotPaging().then(rs => {
    staffs = rs.map(_it => {
      return {
        label: `${_it.code} - ${_it.name}`,
        key: _it._id,
      }
    })
  }).catch(e => {
    ElNotification({
      title: 'Error',
      message: e,
      type: 'error',
    })
  })
}

onMounted(() => {
  getList()
  getStaffs()
})
</script>
<style scoped>
.el-transfer-panel {
  width: 40% !important;
}
</style>
